const NotMatch = () => (
  <div>
    <h2>Page Not Found !!!</h2>
  </div>
);

export default NotMatch;
